import CurrencyAmount from '@components/currency-amount/CurrencyAmount';
import { MemberDiscountLine } from '@types';
import { formatISODate } from '@utils/date';

type MemberCustomTermDiscountTooltipContentProps = {
  originalAmount: number;
  discountLines: MemberDiscountLine[];
  afterDiscountAmount: number;
};

const formatDiscountDate = (iso?: string) => {
  if (!iso) return '';
  return formatISODate({
    date: iso,
    format: 'MMM DD, YYYY',
    separator: '-'
  });
};

const rowLabelClass = 'text-sm font-normal text-white/65';
const valueWhiteSymbol = '!text-sm !font-normal tabular-nums text-white';
const valueWhiteAmount = '!text-sm !font-medium tabular-nums text-white';

const MemberCustomTermDiscountTooltipContent = ({
  originalAmount,
  discountLines,
  afterDiscountAmount
}: MemberCustomTermDiscountTooltipContentProps) => (
  <div className="flex min-h-0 w-max flex-col rounded-lg bg-cofeeGreyBlue11 px-3 py-2.5 text-left shadow-lg">
    <div className="flex shrink-0 items-start justify-between gap-3 border-b border-cofeeNeutral10 pb-2.5">
      <span className={rowLabelClass}>Original fee amount</span>
      <CurrencyAmount
        value={originalAmount}
        className="shrink-0 justify-end gap-0.5"
        symbolClass={valueWhiteSymbol}
        valueClass={valueWhiteAmount}
      />
    </div>

    <div className="mt-2.5 max-h-52 min-h-0 space-y-2 overflow-y-auto overscroll-contain pr-0.5">
      {discountLines.map((line, index) => (
        <div
          key={`${line.label}-${line.type}-${line.value}-${
            line.applied_on ?? ''
          }`}
          className={`flex flex-col gap-1 ${
            index < discountLines.length - 1
              ? 'border-b border-cofeeNeutral10 pb-2'
              : ''
          }`}
        >
          <span className="inline-flex w-fit rounded-md bg-[#1C2E2E] p-1 text-10 font-semibold text-cofeeTeal3">
            Discount
          </span>
          <div className="flex items-start justify-between gap-2">
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium leading-snug text-white">
                {line.label}
              </p>
              {line.applied_on ? (
                <p className="mt-1 text-xs font-normal leading-snug text-white/45">
                  Discounted on {formatDiscountDate(line.applied_on)}
                </p>
              ) : null}
            </div>
            <span className="inline-flex shrink-0 items-baseline gap-1 text-sm font-medium text-cofeeTeal3">
              <span className="text-cofeeTeal3">-</span>
              <CurrencyAmount
                value={Math.abs(Number(line.amount))}
                className="justify-end gap-0.5"
                symbolClass="!text-sm !font-normal text-cofeeTeal3"
                valueClass="!text-sm !font-semibold text-cofeeTeal3"
              />
            </span>
          </div>
        </div>
      ))}
    </div>

    <div className="mt-2.5 shrink-0 border-t border-cofeeNeutral10 pt-2">
      <div className="flex items-start justify-between gap-3">
        <span className={rowLabelClass}>After discount amount</span>
        <CurrencyAmount
          value={afterDiscountAmount}
          className="shrink-0 justify-end gap-0.5"
          symbolClass={valueWhiteSymbol}
          valueClass="!text-sm !font-semibold tabular-nums text-white"
        />
      </div>
    </div>
  </div>
);

export default MemberCustomTermDiscountTooltipContent;
